'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialTwitchOutline = function IoSocialTwitchOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6 2.5h30v21.3l-8.7 8.7h-6.3l-5 5h-5v-5h-7.5v-23.7z m26.3 20v-16.2h-23.8v21.2h6.3v5l5-5h7.5z m-7.5-1.2v-10.1h3.7v10.1h-3.7z m-8.8 0v-10.1h3.8v10.1h-3.8z' })
        )
    );
};

exports.default = IoSocialTwitchOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-twitch-outline.js
// module id = 2476
// module chunks = 0